export default (header = '.header', footer = '.footer', main = 'main') => () => 

  document.querySelector(main) &&

  document.querySelector(header) &&

  document.querySelector(footer) && 

  (document.querySelector(main).style.minHeight = `calc(100vh - ${

    document.querySelector(header).getBoundingClientRect().height

  }px - ${

    document.querySelector(footer).getBoundingClientRect().height

  }px)`);
